// bounty
import {HREF, get} from '@acng/frontend-bounty/dom/attribute.js';
import {getParentElement} from '@acng/frontend-bounty/dom/query.js';
import {isHTMLElement} from '@acng/frontend-bounty/dom/type.js';
import {ANCHOR, DETAILS} from '@acng/frontend-bounty/dom/element.js';
import {debug} from '@acng/frontend-bounty/dom/debug.js';
// nova
import {STYLE_ACTIVE, swapClass} from './style.js';
import {all} from '@acng/frontend-bounty/dom/document.js';

/**
 * Determine if the given `anchor` points to the current location.
 *
 * The check is done by testing if the anchors "href" attribute value
 * is found in {@link !Location["hash"]}
 *
 * Since {@link !HTMLAnchorElement["href"]} is tainted by the browser,
 * use the raw corresponding attribute value.
 *
 * @type {(anchor: HTMLAnchorElement) => void}
 */
export const toggle = (anchor) => {
  const href = get(anchor, HREF);
  const locationHref = location.hash;
  const match = locationHref === href;

  DEBUG: if (debug(anchor)) {
    if (match) {
      console.log('set active', {anchor, href, locationHref});
    } else {
      console.debug('set inactive', {anchor, href, locationHref});
    }
  }

  swapClass(anchor, STYLE_ACTIVE, match);

  if (match) {
    /**
     * @type {Element | null}
     */
    let details = anchor;

    while ((details = getParentElement(details))) {
      if (isHTMLElement(details, DETAILS)) {
        DEBUG: if (debug(anchor)) console.log('also set active', {anchor, details});

        swapClass(details, STYLE_ACTIVE);
      }
    }
  }
};

export const toggleAll = () => {
  //DEBUG: if (VERBOSE) console.debug(MODULE, 'location change');
  for (const details of all(DETAILS)) {
    //DEBUG: if (VERBOSE || details.hasAttribute('debug')) console.debug(MODULE, 'reset', {details});
    swapClass(details, STYLE_ACTIVE, false);
  }

  for (const anchor of all(ANCHOR)) {
    toggle(anchor);
  }
};
